import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="py-12 px-6 md:px-12 border-t border-gray-200 bg-[#F9F8F6]">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        <div className="flex flex-col gap-1">
            <span className="font-serif font-bold text-primary">LeadFraud.org</span>
            <span className="text-[10px] text-gray-400 uppercase tracking-wider">Est. 2025</span>
        </div>
        
        <div className="text-xs text-gray-500 font-medium">
          Built as an independent standards initiative.
        </div>

        <div className="flex gap-6 text-xs text-gray-600 font-medium">
            <span className="cursor-not-allowed opacity-50">Contact</span>
            <span className="cursor-not-allowed opacity-50">LinkedIn (coming soon)</span>
        </div>
      </div>
    </footer>
  );
};

